import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import styled from 'styled-components';
const Container = styled.div `
  --dropdownMaxWidth: 300px;
  --columns: 2;

  position: absolute;
  top: 100%;
  left: -24px;
  min-width: max-content;
  max-width: var(--dropdownMaxWidth);
  padding: 12px 0 24px;
  background-color: ${brand.global.white};
  color: ${brand.primary.purple.base};
  border-bottom-right-radius: 30px;

  opacity: 0;
  pointer-events: none;
  ${transition('opacity', '0.2s')}

  &[data-visible='true'], 
  &:focus-within {
    opacity: 1;
    pointer-events: auto;
  }

  [data-dropdown-type='two-column'] & {
    --dropdownMaxWidth: ${fluid(500, 800, Device.TabletLarge)};

    left: -50px;
    padding: 24px 50px;
    min-width: unset;
    width: var(--dropdownMaxWidth);
  }
`;
const DropdownList = styled.ul `
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 70vh;
  overflow-y: auto;
  ${scrollbars}

  [data-dropdown-type='two-column'] & {
    display: block;
    max-height: unset;
    overflow: unset;
    columns: 2;
    gap: 24px;

    > li {
      margin-bottom: 8px;

      > a {
        ${fonts.openSans.light}
        font-size: ${fluid(14, 16, Device.TabletLarge)};
        padding: 0;

        &:hover,
        &:focus-visible {
          background-color: transparent;
          text-decoration: underline;
          text-underline-offset: 2px;
        }
      }
    }
  }
`;
const DropdownItem = styled.li `
  ${Container} {
    --dropdownMaxWidth: ${fluid(500, 800, Device.TabletLarge)};

    top: 0;
    left: 100%;
    padding: 24px 50px;
    min-width: unset;
    width: var(--dropdownMaxWidth);

    > ul {
      display: block;
      columns: var(--columns);
      gap: 24px;

      > li {
        margin-bottom: 8px;

        > a {
          ${fonts.openSans.light}
          font-size: ${fluid(14, 16, Device.TabletLarge)};
          padding: 0;

          &:hover,
          &:focus-visible {
            background-color: transparent;
            text-decoration: underline;
            text-underline-offset: 2px;
          }
        }
      }
    }
  }
`;
const DropdownLink = styled.a `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  ${fonts.ubuntu.medium}
  font-size: ${fluid(14, 18, Device.TabletLarge)};
  padding: 12px 24px;
  color: currentColor;
  text-decoration: none;

  &:hover,
  &:focus-visible,
  [aria-expanded='true'] > & {
    background-color: ${brand.tertiary.nearlyWhite.light};
  }

  svg {
    --iconSize: ${fluid(16, 20, Device.TabletLarge)};

    width: var(--iconSize);
    height: var(--iconSize);
    margin-bottom: -2px;
  }
`;
const DropdownTitle = styled.span `
  display: block;
  ${fonts.ubuntu.bold}
  font-size: ${fluid(14, 18, Device.TabletLarge)};
  margin-bottom: 12px;
`;
const NavigationDropdownStyles = {
    Container,
    DropdownList,
    DropdownItem,
    DropdownLink,
    DropdownTitle,
};
export default NavigationDropdownStyles;
